import { Link, useLocation } from "react-router-dom";
import { LayoutDashboard, List, Plus, Settings, Upload, BarChart3, LogOut, TrendingUp, Cpu, Activity, Plug } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { NotificationBell } from "./NotificationBell";

export const Layout = ({ children }) => {
  const location = useLocation();
  const { user, logout } = useAuth();

  const navItems = [
    { path: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
    { path: "/analytics", label: "Analytics", icon: TrendingUp },
    { path: "/trades", label: "All Trades", icon: List },
    { path: "/add-trade", label: "Add Trade", icon: Plus },
    { path: "/signals", label: "Upload Signals", icon: Upload },
    { path: "/signals-dashboard", label: "View Signals", icon: BarChart3 },
    { path: "/strategies", label: "Strategies", icon: Cpu },
    { path: "/trade-signals", label: "Trade Signals", icon: Activity },
    { path: "/speedbot", label: "SpeedBot", icon: Plug },
    { path: "/settings", label: "Settings", icon: Settings },
  ];

  return (
    <div className="min-h-screen bg-obsidian">
      {/* Top Navigation Bar */}
      <nav className="bg-obsidian/80 backdrop-blur-md border-b border-white/10 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between gap-3 h-16">
            <div className="flex-shrink-0">
              <img 
                src="https://customer-assets.emergentagent.com/job_stocktracker-243/artifacts/ledhfika_250%20x%20100%20-%20TAP-AASMA%20Logo.png" 
                alt="TAP AASMA" 
                className="h-12 w-auto object-contain"
              />
            </div>
            <div className="flex items-center gap-1 min-w-0 flex-wrap justify-end">
              {navItems.map((item) => {
                const Icon = item.icon;
                const isActive = location.pathname === item.path;
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
                    className={`nav-link flex items-center gap-1.5 px-2.5 py-2 rounded-sm text-xs xl:text-sm font-medium whitespace-nowrap ${
                      isActive
                        ? "bg-white/15 text-white border-l-2 border-profit"
                        : "text-slate-300 hover:text-white"
                    }`}
                  >
                    <Icon className="w-4 h-4 flex-shrink-0" />
                    <span className="hidden lg:inline">{item.label}</span>
                  </Link>
                );
              })}
              
              {/* Notification Bell and User info */}
              {user && (
                <div className="flex items-center gap-2 ml-2 pl-2 border-l border-white/10 flex-shrink-0">
                  <NotificationBell />
                  {user.picture && (
                    <img 
                      src={user.picture} 
                      alt={user.name} 
                      className="w-7 h-7 rounded-full flex-shrink-0"
                    />
                  )}
                  <button
                    onClick={logout}
                    className="text-slate-400 hover:text-red-400 transition-colors flex-shrink-0"
                    title="Sign out"
                  >
                    <LogOut className="w-5 h-5" />
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </main>
    </div>
  );
};

export default Layout;
